export default __webpack_public_path__ + "static/media/NEW_JGG_LOGO.0f039058.png";